import { render, staticRenderFns } from "./WeeklyFlowsReport.vue?vue&type=template&id=3b8fe4fe&"
import script from "./WeeklyFlowsReport.vue?vue&type=script&lang=js&"
export * from "./WeeklyFlowsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports